import { List } from '@mui/material';
import MenuOption from './MenuOption';
import SideMenuItemContainer from './SideMenuItemContainer';

interface Props {
  items: MenuOption[];
  childList: Boolean;
}

function SideMenuList({ items, childList }: Props) {
  return (
    <List>
      {items.map((menuItem, index) => (
        <SideMenuItemContainer
          key={'SideMenu' + index}
          menuItem={menuItem}
          parentIndex={index}
          child={childList}
        />
      ))}
    </List>
  );
}

export default SideMenuList;
